export enum SheqManagerDisplayEnum {
    Overview = 1,
    Audit = 2
}